import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { createContext } from "react";

export const CurrencyContext = createContext({});

const FETCH_CURRENCY = gql`
  query FETCH_CURRENCY {
    latestExchangeRate {
      id
      rate
      supplierUsdToRmbRate
    }
  }
`;

const CurrencyProvider = ({ children }) => {
  const { loading, error, data } = useQuery(FETCH_CURRENCY);

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const usdExchangeRates = {
    CNY: data.latestExchangeRate.supplierUsdToRmbRate,
    RMB: data.latestExchangeRate.supplierUsdToRmbRate,
    USD: 1.0,
  };

  return (
    <CurrencyContext.Provider
      value={{
        rmbToUsdRate: 1.0 / data.latestExchangeRate.rate,
        latestExchangeRate: data.latestExchangeRate,
        usdExchangeRates,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export default CurrencyProvider;
